module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kFD3Z"))).then(() => parcelRequire('1iHdE'));